module.exports = __webpack_public_path__ + "d6474d1abff7b3bf01bf80d87d8885a3.fbx";